import type { GroupBase, OptionProps } from 'react-select';

import { Checkbox } from '@chakra-ui/react';

import Option from './option.component';

/**
 * A custom option component for `react-select` that displays a checkbox alongside the option label.
 *
 * @template Option - The type of the option object.
 * @template IsMulti - Boolean indicating if multiple selections are allowed.
 * @template Group - The type of the group object.
 * @param props - The props provided by `react-select` for rendering an option.
 * @returns A JSX element rendering the option with a checkbox and label.
 */
function CheckboxOption<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: OptionProps<Option, IsMulti, Group>
) {
  const { isSelected, label } = props;

  return (
    <Option {...props}>
      <div className="flex min-w-0 items-center truncate">
        <div>
          <Checkbox
            defaultChecked={isSelected}
            readOnly
          />
        </div>
        <div className="ms-3 min-w-0 grow truncate">{label}</div>
      </div>
    </Option>
  );
}

export default CheckboxOption;
